import * as uuid from 'uuid';

export const interpolateString = (str: string, keys?: { [key: string]: string | number }, begin = '{', end = '}') => {
	let fullStr = str;

	if (keys) {
		Object.keys(keys).forEach((key) => {
			keys && keys[key] && (fullStr = fullStr.replace(`${begin + key + end}`, keys[key].toString()));
		});
	}

	return fullStr;
};

export const capitalizeFirstLetter = (str: string) => {
	return str.charAt(0).toUpperCase() + str.slice(1);
};

/**
 * Removes special characters from string, to fit for css selectors
 * @param colClassName string
 */
export const columnClasses = (colClassName: string) => {
	colClassName = colClassName
		.replace(/ /g, '')
		.replace(/%/g, '')
		.replace(/&/g, '')
		.replace(/\//g, '_')
		.replace(/_+$/g, '')
		.replace(/#/g, '')
		.toLowerCase();
	return `${colClassName}Column`;
};

export const stringToBoolean = (str: string | boolean) => {
	if (str === false || str === true) {
		return str;
	} else if (str.toLowerCase() === 'false') {
		return false;
	} else if (str.toLowerCase() === 'true') {
		return true;
	}
};

export const booleanToString = (str: string | boolean) => {
	if (str === false) {
		return 'false';
	} else if (str === true) {
		return 'true';
	} else if (str.toLowerCase() === 'true' || str.toLowerCase() === 'false') {
		return str.toLowerCase();
	}
};

export const getGUIDWithoutDashes = (guid: string) => {
	return guid.replace(/-/g, '');
};

export const addDashToGUID = (guid: string) => {
	if (guid.length === 36) {
		return guid;
	}
	return `${guid.substr(0, 8)}-${guid.substr(8, 4)}-${guid.substr(12, 4)}-${guid.substr(16, 4)}-${guid.substr(20)}`;
};

export const generateGuid = () => {
	return uuid.v4();
};

export const pluralize = (count: number, noun: string, suffix: string = 's') => `${count} ${noun}${count !== 1 ? suffix : ''}`;

export const ordinal = (n: number | any) => {
	const nNumber = parseInt(n, 10);
	if (!isNaN(nNumber)) {
		const cent = n % 100;
		if (cent >= 10 && cent <= 20) {
			return nNumber + 'nth';
		}
		const dec = n % 10;
		if (dec === 1) {
			return nNumber + 'st';
		}
		if (dec === 2) {
			return nNumber + 'nd';
		}
		if (dec === 3) {
			return nNumber + 'rd';
		}
		return nNumber + 'th';
	}
};

export const isValidUUID = (id: string) => {
	const regex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
	return regex.test(id);
};

export const truncateString = (str: string, charsToTruncate: number) => {
	return str.length > charsToTruncate ? str.substr(0, charsToTruncate - 1) + '...' : str;
};

export const formatNumber = (planNumber: number | string) => {
	return planNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const getQueryStringFromLocation = (location: Location) => {
	return location.hash ? (location.hash.split('?').length > 1 ? location.hash.split('?').pop() : '') : location.search;
};

export const addDashesToGuid = (guid: string) => {
	var dashLocations = [8, 13, 18, 23];
	var guidArr = guid.split('');

	for (var i in guidArr) {
		if (guidArr[i] === '-') {
			return guid;
		}
	}

	dashLocations.forEach(function (location, index) {
		guidArr.splice(location, 0, '-');
	});

	return guidArr.join('');
};

export const parseUuid = (uuid: string) => {
	let v;
	const arr = new Uint8Array(16);

	// Parse ########-....-....-....-............
	arr[0] = (v = parseInt(uuid.slice(0, 8), 16)) >>> 24;
	arr[1] = (v >>> 16) & 0xff;
	arr[2] = (v >>> 8) & 0xff;
	arr[3] = v & 0xff;

	// Parse ........-####-....-....-............
	arr[4] = (v = parseInt(uuid.slice(9, 13), 16)) >>> 8;
	arr[5] = v & 0xff;

	// Parse ........-....-####-....-............
	arr[6] = (v = parseInt(uuid.slice(14, 18), 16)) >>> 8;
	arr[7] = v & 0xff;

	// Parse ........-....-....-####-............
	arr[8] = (v = parseInt(uuid.slice(19, 23), 16)) >>> 8;
	arr[9] = v & 0xff;

	// Parse ........-....-....-....-############
	// (Use "/" to avoid 32-bit truncation when bit-shifting high-order bytes)
	arr[10] = ((v = parseInt(uuid.slice(24, 36), 16)) / 0x10000000000) & 0xff;
	arr[11] = (v / 0x100000000) & 0xff;
	arr[12] = (v >>> 24) & 0xff;
	arr[13] = (v >>> 16) & 0xff;
	arr[14] = (v >>> 8) & 0xff;
	arr[15] = v & 0xff;

	return arr;
};
